var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysSendEmail = function SvgSysSendEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.263 14.06-1.67-5.47-4.902-2.943a.501.501 0 0 1 .15-.916l12.423-2.706h.003l.003.001a.5.5 0 0 1 .516.768L9.188 14.138a.494.494 0 0 1-.512.271.502.502 0 0 1-.413-.35Zm.587-1.497 4.1-8.3L7.591 8.45l1.258 4.113ZM3.286 5.44 6.98 7.654l5.349-4.18L3.286 5.44Z"
  })));
};
export default SvgSysSendEmail;